import { z } from "zod";

export const TransactionEnum = {
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw",
  TRADEDEPOSIT: "trade_deposit",
} as const;

export const transactionSchema = z.enum([
  TransactionEnum.DEPOSIT,
  TransactionEnum.WITHDRAW,
  TransactionEnum.TRADEDEPOSIT,
]);

export type TransactionType = z.infer<typeof transactionSchema>;